import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {DragSource, DropTarget} from 'react-dnd'
import {ListItem, ListItemIcon} from '@material-ui/core'
import {DeleteRounded} from '@material-ui/icons'
import ItemTypes from './ItemTypes'

const style = {
  cursor: 'move',
}

const cardSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    }
  },
}

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    if (dragIndex === hoverIndex) {
      return
    }
    const {decoratedComponentInstance} = component
    const hoverBoundingRect = decoratedComponentInstance.card.getBoundingClientRect()
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
    const clientOffset = monitor.getClientOffset()
    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }

    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }
    props.moveListItem(dragIndex, hoverIndex)
    monitor.getItem().index = hoverIndex
  },
}

const withDropTarget = DropTarget(ItemTypes.LIST_ITEM, cardTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))

const withDropSource = DragSource(
  ItemTypes.LIST_ITEM,
  cardSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }),
)

class ReorderListItem extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    handleOnClick: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    isTextType: PropTypes.bool.isRequired,
    id: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired,
    ]),
    text: PropTypes.string.isRequired,
    moveListItem: PropTypes.func.isRequired,
  }

  render() {
    const {
      text,
      isDragging,
      connectDragSource,
      connectDropTarget,
      handleOnClick,
      isTextType,
    } = this.props
    const opacity = isDragging ? 0 : 1

    return connectDragSource(
      connectDropTarget(
        <div
          ref={elm => {
            this.card = elm
          }}
          style={{...style, opacity}}
        >
          <ListItem
            style={{display: 'flex', justifyContent: 'space-between'}}
            onClick={handleOnClick}
          >
            {text}
            {(() => {
              if (isTextType) {
                return (
                  <ListItemIcon>
                    <DeleteRounded />
                  </ListItemIcon>
                )
              }
                return <div />
            })()}
          </ListItem>
        </div>,
      ),
    )
  }
}

export default withDropTarget(withDropSource(ReorderListItem))



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/responseMessage/components/ReorderListItem.js